<template>
  <div 
    class="popupWrap" 
    :class="{ 'active' : openOrClose }" 
    @click="dimmedClickHandler" 
  >
    <div class="contentWrap" ref="contentWrap">
      <h2>{{ crntObj.publishType ? "공개하기" : "수정 버전 저장" }}</h2>
      
      <dl class="info" v-if="crntObj.publishType">
        <dt><span>범위</span></dt>
        <dd :class="cautionBlnPublic ? 'caution' : null">
          <label><input type="radio" name="publicActive" v-model="publicActive" value="1"/>일반회원 이상</label>
          <label><input type="radio" name="publicActive" v-model="publicActive" value="2"/>위원/간사</label>
        </dd>
      </dl>
      <p v-if="cautionBlnPublic" class="caution">공개 범위를 선택해주세요.</p>
      <dl class="desc">
        <!-- <dt>수정사항 참고</dt> -->
        <dd :class="cautionBln ? 'caution' : null">
          <p v-if="str ==''" class="placeholder">문서 저장 시 필요한 정보를 입력하세요.</p>
          <p ref="inputWrite" class="write" contenteditable @input="typeHandler"></p>
        </dd>
      </dl>
      <p v-if="cautionBln" class="caution">필수 입력값입니다.</p>
      <p class="explain">
        {{ crntObj.publishType ? "선택한 공개 범위로 공개하시겠습니까?" : "해당 문서 수정 버전을 저장 관리합니다." }}        
      </p>
      <button class="btnConfirm" @click="confirmHandler( $event )">완료</button>
      <close-btn :closeHandler="clickCloseHandler" />
    </div>
    <div class="canvas" ref="publishCanvas"></div>
    <Loading :visible="loading" type="fixed"/>
  </div>
</template>

<script>
import CloseBtn from '@components/btns/CloseBtn.vue'; 
import GO from "gojs";
import mixin from "@/mixins/process";
import Loading from '@common/loading.vue'
const goMake = GO.GraphObject.make;

export default {
  mixins: [mixin],
  components : {
    CloseBtn , Loading
  } , 
  props : {
    crntObj : Object , 
  } , 
  data () {
    return {
      diagram: {},
      cautionBln : false , 
      cautionBlnPublic : false,
      str : '' , 
      publicActive : 0,
      loading : false,
    }
  } , 
  computed : {
    openOrClose ( bln ) {
      if ( this.crntObj.openBln ) {
        setTimeout(_=>{
          this.$refs.inputWrite.focus() ; 
        } , 100 ) ; 
      }
      return this.crntObj.openBln ; 
    } , 
  } , 
  async mounted () {
    await this.$nextTick() ; 
  } , 
  methods : {
    async confirmHandler ( e ) {
      if( this.crntObj?.publishType === true ){
        this.cautionBlnPublic = this.publicActive == 0 ? true : false ; 
        if( !this.publicActive ){
          return;
        }        
      }

      this.cautionBln = this.str == '' ? true : false ; 
      if ( this.str == '' ) {
        this.$refs.inputWrite.focus() ; 
        return ; 
      }
      this.loading = true;
      await this.$emit("saveAndRefresh");
      const id = this.$route.query.processId ;
      const processDetail = await this.$wApi.process.detail(null, id ) ;
      if (processDetail?.error || processDetail == null) {
        window.alert("서버와 통신중 오류가 발생했습니다.<br>잠시후 다시 시도해 주세요.");
        return;
      }
      const processType = processDetail.processType;
      let imageBase64 = ""
      if( this.publicActive ){
        // 최초 1회만 공개시 사용자에게 confirm 받음. only protocol만.
        // if(processDetail.publicActive == 0 && processType == "ONLY_PROTOCOL") {
        // 최초 1회만 공개시 사용자에게 confirm 받음. unit 제외 only protocol만.
        if(processDetail?.publicActive == 0 && this.crntObj?.crntProtocol?.protocolType != "UNIT" && processType == "ONLY_PROTOCOL") {
          let confirmMsg = "프로토콜의 재료,목적,장비는 공개시 수정 불가능 합니다.<br><br>공개를 진행 하시겠습니까?";
          // only_protocol의 경우 재료, 목적, 장비가 모두 선택되었는지 확인 후 confirm 메시지를 다르게 띄움. 
          if (!this?.crntObj?.nodeSetComplete ) {
            confirmMsg += "<br><br><font color='red'>[ 현재 프로토콜은 재료,목적,장비 중 입력되지 않은 정보가 존재합니다. ]</font>";
            const bool = await window.confirm(confirmMsg);
            if (!bool) {
              this.loading = false;
              return;
            }
          } else {
            const bool = await window.confirm(confirmMsg);
            if (!bool) {
              this.loading = false;
              return;
            }
          }
        }
        
        await this.diagramInit(id);
        await this.$wApi.process.modify({publicActive:this.publicActive}, id);

        let diagramImage = this.diagram.makeImage({
          scale: 1,
          background: '#fff',
          type: "image/jpeg"
        });
        // console.log( diagramImage.src )
        imageBase64 = diagramImage.src.replace('data:image/jpeg;base64,','');
      }

      const rslt = await this.$wApi.process.log.put({ thumbnail : imageBase64, memo : this.str, publicActive : this.publicActive } , id ) ;
      this.loading = false;
      // console.log({ rslt }) ; 
      if( this.publicActive == 0 ){
			  window.wToast("수정 버전 저장이 완료되었습니다." , { variant: "wtoast-bg", }) ; 
      }else{
        this.$router.go( this.$router.currentRoute ) ;
      }
      this.str = '' ; 
      this.publicActive = 0;
      this.$refs.inputWrite.textContent = '' ; 
      this.clickCloseHandler( e ) ; 
    } , 
    typeHandler () {
      let { $refs: { inputWrite }} = this ; 
      this.str = inputWrite.textContent ; 
    } , 
    dimmedClickHandler ( e ) {
      if ( this.loading ) return;
      if ( !this.crntObj.openBln ) return ; 
      if ( !this.$refs.contentWrap.contains( e.target ) ) {
        // this.crntObj.closeHandler() ; 
        this.clickCloseHandler( e ) ; 
      }
    } , 
    clickCloseHandler ( e ) {
      e.preventDefault() ; 
      e.stopPropagation() ; 

      this.cautionBln = false ; 
      this.crntObj.closeHandler() ; 
    } , 

    async diagramInit(id) {
      // diagram 설정
      const nodeTemplateMapped = new GO.Map();
      this.releaseDiagram(this.$refs.publishCanvas);
      this.refreshNodeStyleMap();
      this.nodeStyleMap.forEach((nodeData, key)=>{
        nodeTemplateMapped.add(
          `${key}`,
          goMake(
            GO.Node, 'Auto', {
              margin:2,
              // locationSpot: GO.Spot.Center,
            },
            new GO.Binding("location", "position", GO.Point.parse).makeTwoWay(GO.Point.stringify),
            goMake(GO.Panel,'Auto', 
              ...nodeData.nodeTemplate,
            ),
          ),
        )
      })
      this.diagram = new GO.Diagram(this.$refs.publishCanvas, {
        layout: goMake(GO.LayeredDigraphLayout, {
          isOngoing: false,
          isInitial: false
        }),
        // 확대 정도
        scale: .5,
        maxScale: 3,
        minScale: 0.2,
        linkTemplate: this.linkTemplate,
        nodeTemplateMap: nodeTemplateMapped
      });
      this.diagram.isReadOnly = true;

      let response = await this.$wApi.process.detail(null, id);
      const data = JSON.parse(response.json);      

      this.diagram.model = new GO.GraphLinksModel(
        {
          nodeDataArray: data.nodes,
          linkDataArray: data.links,
        }
      );      
    },    
  } , 
}
</script>

<style lang="scss" scoped>
  @import "@/style/popup.scss";
  .popupWrap {
    backdrop-filter: blur( 0px ) !important; 
    .canvas{
      width:0;
      height:0;
    }
    .contentWrap {
      --cautionClr: #F64E4E; 
      width: 448px; 
      min-height: 255px; 
      height: fit-content; 
      gap: var( --default-gap ); 

      > h2 {
        font-size: 20px; 
        justify-content: start; 
      }

      dl {
        &.info {
          display: flex; 
          > dt , > dd { 
            height: 37px; 
            border: 1px solid $gray-9; 
            display: flex; 
            align-items: center; 
            @include text-prt-sb; 
            font-size: 14px; 
          }
          > dt {
            width: 102px; 
            flex-shrink: 0; 
            justify-content: center; 
          }
          > dd {
            width: 100%; 
            margin-left: -1px; 
            padding-left: 16px; 
            gap:10px;
            &.caution {
              border: 1px solid var( --cautionClr );
            }            
            >label{
              display:flex;
              gap:4px;
              align-content: center;
              >input[radio]{
                width: 20px; height: 20px;
                border: 2px solid #999;
                border-radius: 50%;
                appearance: none;
                &:checked {
                  background: url('@assets/icons/icon-check-circle.svg') center no-repeat;
                  border-color: #000;
                }
                cursor: pointer;
              }
            }
          }
        } // end of .info 

        &.desc {
          --gap: 8px; 
          display: flex; 
          flex-direction: column; 
          gap: var( --gap ); 

          > dt , > dd {
            @include text-prt-sb; 
            color: $gray-3; 
          }
          > dt {
            font-size: 16px; 
          }
          > dd {
            font-size: 14px; 
            position: relative; 
            padding: var( --gap ); 
            border: 1px solid $gray-9; 

            &.caution {
              border: 1px solid var( --cautionClr );
            }

            p.placeholder {
              color: $gray-d;
              position: absolute; 
              z-index: 1; 
              left: var( --gap ); 
              top: var( --gap ); 
            }
            p.write {
              position: relative; 
              z-index: 2; 
              color: $gray-3;
              height: calc( 80px - ( var( --gap ) * 2 )); 
              overflow-x: hidden; 
              overflow-y: auto; 
              @include scrlbar; 
            }
          }
        } // end of .desc 
      } // end of dl 

      > p {
        &.caution {
          @include text-prt-m; 
          font-size: 12px; 
          color: var( --cautionClr ); 
          display: flex; 
          gap: 4px; 
          align-items: center; 
          margin-top: -8px; 

          &::before {
            display: inline-flex; 
            flex-shrink: 0; 
            content: ''; 
            width: var( --default-gap ); height: var( --default-gap ); 
            background: url('@/assets/icons/icon-alert.svg') no-repeat center center ; 
          }
        }
        &.explain {
          display: flex; 
          @include text-prt-m; 
          font-size: 16px; 
          color: $gray-3; 
          justify-content: center; 
        }
      }
    } // end of .contentWrap
  } // end of .popupWrap

  .btnConfirm {
    @include btn-confirm; 
    align-self: center; 
  }
</style>